// extracted by mini-css-extract-plugin
module.exports = {"globalizationChooser":"GlobalizationChooser_globalizationChooser__1rBv7"};